module.exports = __webpack_public_path__ + "img/20190802132218447.4cff21cc.png";